const user = {
    state: {
        id: null,
        name: null,
        email: null,
        username: null,
        ldap_identifier: null,
        is_active: false,
        alis_id: null,
        remember_token: null,
        created_at: null,
        updated_at: null
    },
    mutations: {
        SET_USER_DATA(state, payload) {
            state.id = payload.id
            state.name = payload.name
            state.email = payload.email
            state.username = payload.username
            state.ldap_identifier = payload.ldap_identifier
            state.is_active = payload.is_active
            state.alis_id = payload.alis_id
            state.remember_token = payload.remember_token
            state.created_at = payload.created_at
            state.updated_at = payload.up
        }
     },
    // actions: { ... },
    // getters: { ... }
}

export default user;
